import { Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useColums from "./useColums";

export default function Tabla() {
  const { sucursalesColumns } = useColums();
  const { proveedorSucursales } = useSelector(
    (state) => state.proveedoresReducer.proveedor
  );

  const [listaFinal, setListaFinal] = useState([]);

  useEffect(() => {
    setListaFinal(proveedorSucursales);
  }, [proveedorSucursales]);

  ///

  const filter = ({ target }) => {
    if (target.value !== "") {
      var newList = proveedorSucursales.filter(
        (a) =>
          a.nombre &&
          a.nombre.toLowerCase().includes(target.value.toLowerCase())
      );
      setListaFinal(newList);
    } else {
      setListaFinal(proveedorSucursales);
    }
  };

  return (
    <>
      <Input
        onChange={filter}
        placeholder="buscar"
        style={{ width: 300, marginBottom: 10 }}
      />
      <Table
        rowKey="proveedorSucursalID"
        columns={sucursalesColumns}
        dataSource={listaFinal}
      />
    </>
  );
}
